if (!customElements.get('journal-editorial-options')) {
  customElements.define('journal-editorial-options', class extends HTMLElement {
    connectedCallback() {
      const article = this.closest('.pp-journal');
      if (!article) return;
      this.apply = () => {
        for (const template of this.querySelectorAll('template[data-heading]')) {
          if (template.dataset.applied) continue;
          const normalize = text => text.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
          const heading = Array.from(article.querySelectorAll('.journal-layout-label h2,.journal-layout-label h3')).find(el => normalize(el.textContent) === normalize(template.dataset.heading));
          if (!heading) continue;
          const label = heading.closest('.journal-layout-label');
          const body = label.parentElement.querySelector('.journal-layout-content');
          if (!body) continue;
          template.dataset.applied = 'true';
          const content = template.content.cloneNode(true);
          const eyebrow = content.querySelector('[data-editorial-eyebrow]');
          if (eyebrow) label.prepend(eyebrow);
          label.append(...content.querySelector('[data-editorial-heading]').childNodes);
          body.append(...content.querySelector('[data-editorial-body]').childNodes);
        }
      };
      this.observer = new MutationObserver(this.apply);
      this.observer.observe(article, { childList: true, subtree: true });
      this.apply();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
